<template>
  <div class="product-page">
    <!-- ===== 01 顶部 Section1 + 核心关键词 -->
    <section class="gradient-blue relative">
        <div class="max-w-6xl mx-autopx-4 sm:px-8"> <!-- removed centering to allow left-aligned hero -->
            <div class="max-w-5xl"> <!-- 左侧内容区 -->
                <h1 style="color:#fff">
                     审计，风险管理、合规<br>防范企业风险、促进业务合规、推动营收增长 <br>
                </h1>
                <p class="mt-6 text-xl text-white/80 max-w-2xl">
                古杉数据提供全栈式企业级产品服务—— 智慧审计、风险管理、合规系统、数据审计、人工智能审计、人工智能数据治理、AI数据管理、AI分析，以灵活模式开启企业长期价值陪伴。<br>赋能内部审计数字化转型 · 助力科技强审 · 构建智能审计平台
                </p>

                <!-- 关键词云（SEO强化） -->
                <div class="rc-keyword-cloud">
                    <h2 class="rc-keyword-tag highlight">企业风控系统</h2>
                    <h2 class="rc-keyword-tag">内部审计系统</h2>
                    <h2 class="rc-keyword-tag">审计管理平台</h2>
                    <h2 class="rc-keyword-tag">数字化审计系统</h2>
                    <h2 class="rc-keyword-tag">风险管理系统</h2>
                    <h2 class="rc-keyword-tag">风险管控平台</h2>
                    <h2 class="rc-keyword-tag">风险预警系统</h2>
                    <h2 class="rc-keyword-tag">风险治理平台</h2>
                    <h2 class="rc-keyword-tag">全面风险管理</h2>
                    <h2 class="rc-keyword-tag">AI人工智能审计</h2>
                </div>

                <!-- 
                <div class="mt-10 flex flex-wrap gap-5">
                    <a href="#consult-form" class="px-8 py-4 bg-white text-brand rounded-lg text-base font-semibold shadow-lg hover:bg-gray-50 transition">预约专家咨询</a>
                    <a href="#subscription-anchor" class="px-8 py-4 bg-transparent text-white border-2 border-white/50 rounded-lg text-base font-semibold hover:bg-white/10 transition">查看订阅服务</a>
                </div>

                -->

                <!-- 内部链接 -->
                <div class="mt-6 text-sm text-white/70">
                    <a href="#" class="text-white hover:underline">数字化转型咨询</a> · <a href="#" class="text-white hover:underline">数据治理咨询</a> · <a href="#" class="text-white hover:underline">AI及大模型</a>
                </div>
                <p class="mt-4 text-sm text-white/70">已服务50+央企国企，包括国家能源集团、中国人寿、一汽集团等</p>
            </div>
        </div>
    </section>

    <!-- 三层架构图 -->
    <section class="section-container">
        <h2 class="section-title text-3xl text-center mb-12">三层一体 · 全栈审计智能平台</h2>
        <div class="flex flex-col items-center md:flex-row md:justify-between gap-4 md:gap-2 relative">
            <div class="arch-layer flex-1 w-full md:w-1/3">
                <i class="fas fa-database text-4xl text-[#1F3F8F] mb-3"></i>
                <h3>数据底座层</h3>
                <p class="text-sm mt-2">审计数据集市 · 政府权威信息采集 · 数据模型</p>
                <div class="mt-3 flex flex-wrap justify-center gap-1">
                    <span class="tag">多源接入</span>
                    <span class="tag">实时采集</span>
                    <span class="tag">数据治理</span>
                </div>
            </div>
            <div class="arch-arrow md:rotate-0 rotate-90">
                <i class="fas fa-arrow-up"></i>
                <i class="fas fa-arrow-up -ml-3 opacity-60"></i>
            </div>
            <div class="arch-layer flex-1 w-full md:w-1/3">
                <i class="fas fa-clipboard-list text-4xl text-[#1F3F8F] mb-3"></i>
                <h3>作业管理层</h3>
                <p class="text-sm mt-2">审计作业 · 疑点分析 · 整改闭环 · 经责评价</p>
                <div class="mt-3 flex flex-wrap justify-center gap-1">
                    <span class="tag">疑点挖掘</span>
                    <span class="tag">整改跟踪</span>
                    <span class="tag">经济责任</span>
                </div>
            </div>
            <div class="arch-arrow md:rotate-0 rotate-90">
                <i class="fas fa-arrow-up"></i>
                <i class="fas fa-arrow-up -ml-3 opacity-60"></i>
            </div>
            <div class="arch-layer flex-1 w-full md:w-1/3">
                <i class="fas fa-chart-line text-4xl text-[#1F3F8F] mb-3"></i>
                <h3>智能决策层</h3>
                <p class="text-sm mt-2">审计指挥舱 · 经营画像 · AI审计 · 风险预警</p>
                <div class="mt-3 flex flex-wrap justify-center gap-1">
                    <span class="tag">实时监控</span>
                    <span class="tag">智能预测</span>
                    <span class="tag">指挥调度</span>
                </div>
            </div>
        </div>
        <p class="text-gray-600 mt-10 text-sm font-bold" style="font-size: 16px;">* 数据驱动、作业闭环、决策智能，全面支撑科技强审</p>
    </section>

    <!-- 产品卡片矩阵 -->
    <section class="section-container">
        <h2 class="section-title text-3xl text-center mb-12">完整产品矩阵 · 按需构建</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <!-- 1. 审计管理系统 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计管理系统</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">审计计划</span>
                    <span class="tag">项目管理</span>
                    <span class="tag">底稿管理</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">全流程审计计划、资源调度与档案管理，实现审计业务协同。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-management')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 2. 审计作业系统 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计作业系统</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">现场作业</span>
                    <span class="tag">疑点管理</span>
                    <span class="tag">底稿编制</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">移动端+PC端一体化，支持离线取证、疑点实时上报。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-operation')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 3. 审计监督评价系统 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计监督评价系统</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">监督预警</span>
                    <span class="tag">绩效评价</span>
                    <span class="tag">问题跟踪</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">对审计质量、整改成效进行量化评价，形成监督闭环。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-supervision')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 4. 审计数据集市 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计数据集市</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">数据采集</span>
                    <span class="tag">数据治理</span>
                    <span class="tag">数据服务</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">整合财务、业务、外部数据，构建审计专用数据湖。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-data-market')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 5. 审计指挥舱 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计指挥舱</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">实时监控</span>
                    <span class="tag">风险地图</span>
                    <span class="tag">指挥调度</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">领导驾驶舱，动态呈现审计项目进展与风险态势。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-command-center')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 6. 审计经营画像 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计经营画像</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">企业画像</span>
                    <span class="tag">风险画像</span>
                    <span class="tag">决策支持</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">多维度勾勒被审计单位经营特征，辅助精准决策。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-business-profile')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 7. 经责审计智能评价 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">经责审计智能评价</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">经责评价</span>
                    <span class="tag">指标模型</span>
                    <span class="tag">任中审计</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">内置评价指标体系，自动生成经责审计报告。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('economic-responsibility-audit')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 8. 政府权威信息采集 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">政府权威信息采集</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">政策采集</span>
                    <span class="tag">舆情监测</span>
                    <span class="tag">数据抓取</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">实时抓取监管动态、处罚信息，为审计提供外部证据。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('government-info-collection')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 9. 审计整改闭环系统 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计整改闭环系统</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">问题整改</span>
                    <span class="tag">跟踪督办</span>
                    <span class="tag">销号管理</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">整改任务线上流转，到期预警，确保问题见底清零。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-rectification')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 10. 审计疑点分析系统 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计疑点分析系统</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">疑点挖掘</span>
                    <span class="tag">智能分析</span>
                    <span class="tag">线索推荐</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">通过算法模型自动识别异常交易，推送审计线索。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-anomaly-analysis')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 11. AI 审计 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">AI 审计</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">智能查账</span>
                    <span class="tag">NLP分析</span>
                    <span class="tag">预测模型</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">利用大模型自动阅读合同、凭证，预测风险领域。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('ai-audit')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 12. 审计数据模型 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">审计数据模型</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">审计模型库</span>
                    <span class="tag">指标体系</span>
                    <span class="tag">数据标准</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">预置300+审计模型，支持自定义，快速复用。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('audit-data-model')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>
            <!-- 13. AI辅助自助审计建模 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">AI辅助自助审计建模</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">AI自助建模</span>
                    <span class="tag">拖拉拽建模</span>
                    <span class="tag">自动配置</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">预置1200+审计模型，支持自定义，自动配置，快速复用，审计人员自助建模。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('ai-assisted-audit-modeling')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>

            <!-- 14. 企业风险管理 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">企业风险管理</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">全局风险识别</span>
                    <span class="tag">单个企业风险</span>
                    <span class="tag">企业风险评价</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">通过股权穿透、关联交易和资金流向分析，实现对企业的全面监管。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('enterprise-risk-management')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>

            <!-- 15. 穿透式监管 -->
            <div class="product-card">
                <h3 class="text-xl font-bold text-[#0E1F52] mb-2">穿透式监管</h3>
                <div class="flex flex-wrap gap-2 mt-3">
                    <span class="tag">股权穿透</span>
                    <span class="tag">关联交易</span>
                    <span class="tag">资金流向</span>
                    <span class="tag">场景AI穿透</span>
                </div>
                <p class="text-sm text-gray-600 mt-3">通过股权穿透、关联交易和资金流向分析，实现对企业的全面监管。</p>
                <div class="mt-4 pt-4 border-t border-divider">
                    <button @click="goToProductDetail('penetrating-supervision')" class="btn-detail">查看产品详情 <i class="fas fa-arrow-right ml-1"></i></button>
                </div>
            </div>

        </div>
        <p class="text-gray-600 mt-10 text-sm">
            覆盖范围：<span class="seo-highlight">审计数字化转型</span> · <span class="seo-highlight">内部审计系统</span> · <span class="seo-highlight">智能审计平台</span> · <span class="seo-highlight">审计大数据系统</span> · <span class="seo-highlight">审计管理平台</span> · <span class="seo-highlight">经责审计系统</span> · <span class="seo-highlight">审计风险管理</span> · <span class="seo-highlight">科技强审</span>
        </p>
    </section>

    <!-- 应用场景说明 -->
    <section class="section-container">
        <h2 class="section-title text-3xl text-center mb-12">典型应用场景</h2>
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div class="bg-white p-6 rounded-xl border-l-4 border-[#1F3F8F] shadow-md">
                <i class="fas fa-building text-3xl text-[#1F3F8F] mb-3"></i>
                <h3 class="font-bold text-xl text-[#0E1F52]">集团型企业年度审计</h3>
                <p class="text-sm text-gray-600">覆盖全级次子公司，统一审计标准，实现审计项目全过程数字化。</p>
            </div>
            <div class="bg-white p-6 rounded-xl border-l-4 border-[#1F3F8F] shadow-md">
                <i class="fas fa-user-tie text-3xl text-[#1F3F8F] mb-3"></i>
                <h3 class="font-bold text-xl text-[#0E1F52]">领导干部经济责任审计</h3>
                <p class="text-sm text-gray-600">任中审计、离任审计，自动评价履职情况，生成报告。</p>
            </div>
            <div class="bg-white p-6 rounded-xl border-l-4 border-[#1F3F8F] shadow-md">
                <i class="fas fa-chart-pie text-3xl text-[#1F3F8F] mb-3"></i>
                <h3 class="font-bold text-xl text-[#0E1F52]">专项审计调查</h3>
                <p class="text-sm text-gray-600">如采购、工程、营销等专项，快速构建疑点分析模型。</p>
            </div>
            <div class="bg-white p-6 rounded-xl border-l-4 border-[#1F3F8F] shadow-md">
                <i class="fas fa-eye text-3xl text-[#1F3F8F] mb-3"></i>
                <h3 class="font-bold text-xl text-[#0E1F52]">持续审计监控</h3>
                <p class="text-sm text-gray-600">7×24小时风险监测，实时预警，从事后转向事中事前。</p>
            </div>
        </div>
    </section>

    <!-- 客户价值总结 -->
    <section class="section-container">
        <h2 class="section-title text-3xl text-center mb-12">客户价值</h2>
        <div class="value-card grid md:grid-cols-2 gap-8">
            <div>
                <ul class="space-y-4">
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">审计效率提升60%</span>
                            <p class="text-gray-600">自动化底稿、疑点自动识别，释放人力聚焦高价值分析。</p>
                        </div>
                    </li>
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">风险覆盖率提高80%</span>
                            <p class="text-gray-600">全量数据扫描，从抽样到全样，风险无死角。</p>
                        </div>
                    </li>
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">整改闭环率95%</span>
                            <p class="text-gray-600">问题整改全程跟踪，责任到人，确保落实。</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div>
                <ul class="space-y-4">
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">满足监管要求</span>
                            <p class="text-gray-600">符合国资委、审计署数字化审计指引，一键报送。</p>
                        </div>
                    </li>
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">自主可控信创</span>
                            <p class="text-gray-600">全面适配国产芯片、数据库、操作系统，安全可靠。</p>
                        </div>
                    </li>
                    <li class="flex items-start gap-3">
                        <i class="fas fa-check-circle text-2xl text-green-600 mt-1"></i>
                        <div>
                            <span class="font-bold text-lg text-[#0E1F52]">沉淀审计模型</span>
                            <p class="text-gray-600">持续积累审计经验，形成企业专属模型资产。</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <!-- 底部CTA -->
    <section class="section-container pt-0 text-center">
        <div class="bg-white border border-divider p-12 rounded-3xl shadow-xl">
            <h2 class="text-3xl font-bold text-[#0E1F52] mb-4">开启审计数字化转型之路</h2>
            <p class="text-xl text-[#1F3F8F] mb-8">为央企国企量身打造 · 科技强审 · 即刻咨询</p>
            <a href="#" class="btn-primary">获取完整产品手册</a>
            <p class="text-gray-600 mt-6">服务热线 400-123-4567 · 专家一对一讲解</p>
        </div>
    </section>

    <!-- 页脚 -->
    <footer class="border-t border-divider py-8 text-center text-gray-500 text-sm">
        © 2026 北京古杉数据科技有限公司 · 科技强审 · 自主创新
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Product',
  methods: {
    goToProductDetail(productType) {
      // 跳转到产品详情页面
      this.$router.push({
        name: 'ProductDetail',
        params: { productType }
      })
    }
  }
}
</script>

<style scoped>
/* 青花瓷色系变量（浅色背景优化版） */

.product-page {
    background-color: var(--gray-bg);
    font-family: 'Inter', 'Microsoft YaHei', system-ui, sans-serif;
    position: relative;
    overflow-x: hidden;
    color: var(--ink-blue-gray);
}


.product-page::after {
    content: "";
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background: radial-gradient(circle at 30% 50%, rgba(31,63,143,0.08) 0%, transparent 60%);
    animation: flow 18s infinite alternate;
    z-index: -1;
}

@keyframes flow {
    0% { opacity: 0.3; transform: translate(0,0) scale(1); }
    100% { opacity: 0.7; transform: translate(-1%, -1%) scale(1.02); }
}

/* 模块容器 */
.section-container {
    background-color: white;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding: 40px 12%;
    position: relative;
    z-index: 2;
}

/* 卡片样式（白底，瓷蓝边） */
.product-card {
    background: var(--white);
    border: 1px solid var(--divider);
    border-radius: 20px;
    padding: 24px 16px;
    transition: all 0.3s ease;
    box-shadow: 0 8px 20px -8px rgba(31,63,143,0.1);
}

.product-card:hover {
    transform: translateY(-5px);
    border-color: var(--brand-blue);
    box-shadow: 0 15px 30px -12px rgba(31,63,143,0.2);
}

/* 可点击卡片样式 */
.product-card.clickable {
    cursor: pointer;
}

.product-card.clickable:hover {
    transform: translateY(-8px);
    border-color: var(--brand-blue);
    box-shadow: 0 20px 40px -12px rgba(31,63,143,0.25);
}

.product-card.clickable:active {
    transform: translateY(-4px);
}

.tag {
    background: var(--porcelain-blue);
    color: var(--brand-blue);
    font-weight: 500;
    border-radius: 30px;
    padding: 4px 12px;
    font-size: 0.8rem;
    border: 1px solid rgba(31,63,143,0.2);
}


.gradient-blue {
    background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
    width: 100%;
    padding: 60px 5%; /* 或者使用 px，如 padding: 60px 24px; */
}


.gradient-light {
    background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
}



/* 三层架构图样式 */
.arch-layer {
    background: var(--white);
    border-radius: 30px;
    padding: 30px 20px;
    text-align: center;
    border: 1px solid var(--divider);
    box-shadow: 0 10px 25px -8px rgba(31,63,143,0.15);
    backdrop-filter: blur(2px);
}

.arch-layer h3 {
    color: var(--deep-indigo);
    font-weight: 700;
    font-size: 1.5rem;
}

.arch-layer p {
    color: var(--brand-blue);
}

.arch-arrow {
    font-size: 2rem;
    color: var(--brand-blue);
    margin: 8px 0;
    opacity: 0.8;
}

/* 标题文字 */
.section-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--deep-indigo);
    letter-spacing: 1px;
}

.section-sub {
    font-size: 1.2rem;
    color: var(--brand-blue);
}

.value-card {
    background: var(--white);
    border-radius: 24px;
    padding: 30px;
    border-left: 8px solid var(--brand-blue);
    box-shadow: 0 15px 30px -12px rgba(31,63,143,0.15);
}

.seo-highlight {
    color: var(--brand-blue);
    font-weight: 600;
}

hr {
    border-color: var(--divider);
}

/* 按钮样式 */
.btn-primary {
    background-color: var(--brand-blue);
    color: white;
    padding: 0.75rem 2rem;
    border-radius: 40px;
    font-weight: 600;
    transition: all 0.2s;
    display: inline-block;
    text-decoration: none;
}

.btn-primary:hover {
    background-color: var(--deep-indigo);
}

/* 产品详情按钮样式 */
.btn-detail {
    background-color: var(--brand-blue);
    color: white;
    padding: 0.6rem 1.5rem;
    border-radius: 30px;
    font-weight: 600;
    font-size: 0.9rem;
    transition: all 0.3s;
    display: inline-block;
    text-decoration: none;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(31,63,143,0.2);
}

.btn-detail:hover {
    background-color: var(--deep-indigo);
    transform: translateX(5px);
    box-shadow: 0 6px 16px rgba(31,63,143,0.3);
}

.btn-detail i {
    transition: transform 0.3s;
}

.btn-detail:hover i {
    transform: translateX(3px);
}

.stat-badge {
    background: white;
    border: 1px solid var(--divider);
    border-radius: 20px;
    padding: 1rem 2rem;
    box-shadow: 0 8px 15px -6px rgba(31,63,143,0.1);
}

.bg-porcelain {
    background-color: var(--porcelain-blue);
}

.border-divider {
    border-color: var(--divider);
}


/* 关键词标签云 */
.rc-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.rc-keyword-tag {   
  background: white;
  color: var(--rc-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.rc-keyword-tag.highlight {
  background: #D4AF37;
  color: #1e3c3c;
}

/* Hero content left alignment inside gradient-blue */
.gradient-blue .hero-content {
        max-width: 760px;
}

.gradient-blue .rc-keyword-cloud {
        justify-content: flex-start;
}

/* 标题尺寸 */
h1 {
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
    color: #0b1a33;
}

</style>



